import React, { memo, useEffect, useState } from "react"
import parse from "html-react-parser"
import AOS from "aos"
import { Swiper, SwiperSlide } from "swiper/react"
import { FreeMode, Mousewheel, Navigation, Scrollbar } from "swiper/modules"
import "aos/dist/aos.css"
import "swiper/css/free-mode"
import "swiper/css/scrollbar"
import SectionsTitle from "../../../Common/new/SectionsTitle"
import { replaceUnderscoresWithSpaces } from "../../../utils/functions"
import * as style from "./techstacks.module.css"

const Techstacks = props => {
  const {
    homeTechContent,
    homeTechTitle,
    homeTechShowSection,
    homeTechSubTitle,
    technologyStack,
    technologyStackCategory,
    CustomClass,
  } = props

  // State to track the selected category
  const [selectedCategory, setSelectedCategory] = useState(
    technologyStackCategory?.edges?.[0]?.node?.id
  )

  // Filter the technology stack data based on the selected category
  const filteredData = selectedCategory
    ? technologyStack?.edges.filter(item =>
      item.node.technologyStackscategories.nodes.some(
        cat => cat.id === selectedCategory
      )
    )
    : technologyStack?.edges

  // default category
  useEffect(() => {
    if (
      !technologyStackCategory?.edges.some(
        category => category.node.id === selectedCategory
      )
    ) {
      setSelectedCategory("")
    }
  }, [technologyStackCategory, selectedCategory])

  useEffect(() => {
    AOS.init({
      once: true,
    })
  }, [])
  return (
    <>
      {homeTechShowSection === "yes" && (
        <section
          className={`${CustomClass}`}
          data-aos="fade-up"
          data-aos-delay="50"
        >
          <div className="container">
            <div className="row">
              <div className={style.techstacks_wrap}>
                <SectionsTitle
                  title={replaceUnderscoresWithSpaces(homeTechTitle)}
                  SubTitle={homeTechSubTitle}
                  Content={homeTechContent}
                  styleCss={{ display: "none" }}
                />
                <Swiper
                  slidesPerView={7}
                  freeMode={true}
                  scrollbar={false}
                  mousewheel={true}
                  navigation={true}
                  modules={[FreeMode, Mousewheel, Navigation, Scrollbar]}
                  className={`techswiper ${style.swiperBox}`}
                  breakpoints={{
                    320: {
                      slidesPerView: 3,
                    },
                    575: {
                      slidesPerView: 4,
                    },
                    991: {
                      slidesPerView: 6,
                    },
                    1024: {
                      slidesPerView: 7,
                    },
                  }}
                >
                  {technologyStackCategory?.edges?.map((val, index) => (
                    <SwiperSlide key={index}>
                      <div
                        className={`${style.liDiv} ${selectedCategory === val.node.id ? style.active : ""
                          }`}
                        onClick={() => setSelectedCategory(val.node.id)}
                      >
                        {val?.node?.name}
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>

                {/* Filtered List */}
                <ul className={style.techstacks_listing}>
                  {filteredData?.map((item, index) => (
                    <li key={index}>
                      <div className={style.techstacks_info}>
                        <i>
                          {item.node.TechnologyStackPostFields
                            ?.technologyStackIcon &&
                            parse(
                              `${item.node.TechnologyStackPostFields.technologyStackIcon}`
                            )}
                        </i>
                        <span>{item.node.title}</span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  )
}

export default memo(Techstacks)
